import React from 'react'

const DefaultNavbar = () => {
  return (
      <div className="flex w-full items-center justify-center">
         <div className='w-fit mx-auto text-white flex items-center gap-2'>
              <div className='w-fit bg-white/10 flex items-center p-2 rounded-md gap-2'>
                  <img src="https://assets.learntube.ai/files/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449" loading="eager" alt="" width={24} height={24} className='w-6 h-6'/>
                  <p className='font-medium text-xs'>LearnTube.ai</p>
              </div>
              <div className='h-[36px] w-[2px] bg-white/20' />
              <div className='flex flex-col items-center'>
                  <p className='text-[10px] text-white/50'>backed by</p>
                  <div className='flex gap-1 items-center'>
                  <img src="https://assets.learntube.ai/files/post-payment-updates/use2460.svg?updatedAt=1728356838222" alt="" width={40} height={13} className='w-10 h-auto' />
                  <img src="https://assets.learntube.ai/files/post-payment-updates/text3075.svg?updatedAt=1728356926579" alt="" width={64} height={13} className='w-16 h-auto' />
                  </div>
              </div>
          </div>
      </div>
    );
}

export default DefaultNavbar
